
import { useRouter } from "vue-router";
import Navbar from "./components/Navbar.vue";
import Cookies from "./components/CookiesPopup.vue";
import LoadingModal from "./components/loading/LoadingModal.vue";
export default {
  components: {
    Navbar,
    Cookies,
    LoadingModal,
  },
  setup() {
    const router = useRouter();
    router.afterEach((to) => {
      document.title = to.meta.title
        ? to.meta.title + " · Book searcher "
        : "Book searcher";
    });
  },
};
